import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Grid, Typography } from "@material-ui/core";
import {
  postMedicamentos,
  replaceMedicamentosPorSeleccionados
} from "../../../actions/empadronamiento/Empadronamiento";
import {
  EMPADRONAMIENTO_SOLICITUDES_ESTADOS
} from "../../../utils/constants";
import { EmpadronamientoAddMedicamento } from "./EmpadronamientoAddMedicamento";
import { EmpadronamientoMedicamento } from "./EmpadronamientoMedicamento";
import { EMPADRONAMIENTO_MENU_PERMISOS } from "../../../utils/permisos";
import { validarSoloUnPermiso } from "../../../helpers/permisos";
//import { Redirect } from "react-router-dom";

export const EmpadronamientoMedicamentosModalGestionar = (props) => {
  const dispatch = useDispatch();

  const { medicamentos = [], solicitudSeleccionada = {} } = useSelector(
    (state) => state.empadronamiento
  );
  const { permisos: permisosUser } = useSelector(
    (state) => state.auth
  );

  useEffect(() => {
    dispatch(replaceMedicamentosPorSeleccionados(solicitudSeleccionada?.medicamentos));
  }, []);

  const onClickSiguienteHandler = () => {
    const medicamentosFormateados = medicamentos.map((medicamento) => {
      return {
        idSolicitud: solicitudSeleccionada.idSolicitud,
        idMedicamento: medicamento.idMedicamento,
        cantidad: medicamento.cantidad,
        dosis: medicamento.dosis,
        posologia: medicamento.posologia,
        surge: medicamento.surge,
        idConvenioSC: medicamento.idConvenioSC,
        idTipoEmpadronamiento: solicitudSeleccionada.idTipoEmpadronamiento,
      };
    });

    dispatch(postMedicamentos({ medicamentos: medicamentosFormateados }, false));
  };

  const esCarga = !validarSoloUnPermiso(
    permisosUser,
    EMPADRONAMIENTO_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA
  ) && !validarSoloUnPermiso(
    permisosUser,
    EMPADRONAMIENTO_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA_EXT
  );

  /*
  const esOspe = validarSoloUnPermiso(
    permisosUser,
    EMPADRONAMIENTO_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA
  ) && !validarSoloUnPermiso(
    permisosUser,
    EMPADRONAMIENTO_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA_EXT
  );
  */

  const esCeiba = !validarSoloUnPermiso(
    permisosUser,
    EMPADRONAMIENTO_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA
  ) && validarSoloUnPermiso(
    permisosUser,
    EMPADRONAMIENTO_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA_EXT
  );

  const disabledEnGestionar = esCarga ||
    solicitudSeleccionada?.idEstadoSolicitud === EMPADRONAMIENTO_SOLICITUDES_ESTADOS.PENDIENTE_AUTORIZACION ||
    solicitudSeleccionada?.idEstadoSolicitud === EMPADRONAMIENTO_SOLICITUDES_ESTADOS.ACTIVA ||
    solicitudSeleccionada?.idEstadoSolicitud === EMPADRONAMIENTO_SOLICITUDES_ESTADOS.RECHAZADA ||
    (solicitudSeleccionada?.idEstadoSolicitud === EMPADRONAMIENTO_SOLICITUDES_ESTADOS.PENDIENTE_REVISION && esCeiba);

  const parsearNumero = (valor) => {
    if (!valor) return 0;
    const numero = parseFloat(valor.toString().replace(",", "."));
    return isNaN(numero) ? 0 : numero;
  };
  const sumaTotal = medicamentos.reduce((acumulado, medicamento) => {
    return acumulado + parsearNumero(medicamento.precioSeleccionado);
  }, 0);

  const totalFormateado = new Intl.NumberFormat("es-AR", {
    style: "currency",
    currency: "ARS",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(sumaTotal);

  return (
    <>
      {(solicitudSeleccionada?.idEstadoSolicitud !== EMPADRONAMIENTO_SOLICITUDES_ESTADOS.ACTIVA &&
        solicitudSeleccionada?.idEstadoSolicitud !== EMPADRONAMIENTO_SOLICITUDES_ESTADOS.RECHAZADA
      ) &&
        <EmpadronamientoAddMedicamento disabledEnGestionar={disabledEnGestionar} />}
      {medicamentos
        .filter((medicamento) => medicamento.fechaBaja == null)
        .map((medicamento, index) => {
          return (
            <EmpadronamientoMedicamento
              key={index}
              medicamento={medicamento}
              idTipoEmpadronamiento={solicitudSeleccionada.idTipoEmpadronamiento}
              disabledEnGestionar={disabledEnGestionar}
            />
          );
        })}
      <Grid item style={{textAlign:'center'}}>
        <Typography style={{ fontWeight: 'bold' }}>TOTAL: {totalFormateado}</Typography>
      </Grid>
      <div
        style={{ display: "flex", justifyContent: "center", margin: "2rem" }}
      >
        <Button
          variant="contained"
          color="primary"
          onClick={onClickSiguienteHandler}
          disabled={disabledEnGestionar}
        >
          Guardar Cambios
        </Button>
      </div>
    </>
  );
};